(function () {
	'use strict';

	angular
        .module('app')
        .factory('PhoneService', PhoneService);

	PhoneService.$inject = [];

	function PhoneService() {
		var service = {
		    validateNumber: validateNumber,
		    convertToE164: convertToE164
		};

        // Hardcoded region code, this will be changed in a later PBI.
		var regionCode = 'AU';

		return service;

	    /*
         * Check the supplied phone number to see if it's valid
         *
         * @param {string} - Phone number to be validated
         *
         * @returns {bool} Is the phone number valid
         */
		function validateNumber(phoneNumber) {
		    var result = false;

		    try {
		        result = phoneUtils.isValidNumber(phoneNumber, regionCode);
		    }
		    catch (error) {
		        result = false;
		    }

		    return result;
		}

	    /*
         * Converts the supplied phone number to E.164 format. If the phone number is not valid a blank string will be returned.
         *
         * @param {string} - Phone number to be converted
         *
         * @returns {string} Returns the phone number in E.164 format
         */
		function convertToE164(phoneNumber) {
		    var result = '';

		    try {
		        if (validateNumber(phoneNumber)) {
		            result = phoneUtils.formatE164(phoneNumber, regionCode);
		        }
		    }
		    catch (error) {
		        result = null;
		    }

		    return result;
		}
	}
})();